import { Cartesian3, IntersectionTests, Ray } from "cesium";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
export class PlaneSlopeStrategy {
    getSlopePoint(pointInfo, verticalDirection, setting) {
        let parallelDirTowardsSelf;
        let perpendicularOutDir;
        if (pointInfo.back) {
            parallelDirTowardsSelf = EarthBrainUtils.getDirBetweenTwoCartesians(pointInfo.back.probablePosition, pointInfo.probablePosition);
            const vDir = Cartesian3.cross(parallelDirTowardsSelf, pointInfo.outwardDirection, new Cartesian3());
            perpendicularOutDir = Cartesian3.cross(vDir, parallelDirTowardsSelf, new Cartesian3()); //perpendicular outward
            Cartesian3.normalize(perpendicularOutDir, perpendicularOutDir);
        }
        else if (pointInfo.front) {
            parallelDirTowardsSelf = EarthBrainUtils.getDirBetweenTwoCartesians(pointInfo.front.probablePosition, pointInfo.probablePosition);
            const vDir = Cartesian3.cross(parallelDirTowardsSelf, pointInfo.outwardDirection, new Cartesian3());
            perpendicularOutDir = Cartesian3.cross(vDir, parallelDirTowardsSelf, new Cartesian3()); //perpendicular outward
            Cartesian3.normalize(perpendicularOutDir, perpendicularOutDir);
        }
        let slopeRay;
        let pointOnSlope;
        if (parallelDirTowardsSelf && perpendicularOutDir) {
            const width = setting.moundSlope * setting.slopeHeight;
            const verticalVec = Cartesian3.multiplyByScalar(verticalDirection, setting.slopeHeight, new Cartesian3());
            const horizontalVec = Cartesian3.multiplyByScalar(perpendicularOutDir, width, new Cartesian3());
            const slopeVec = Cartesian3.add(verticalVec, horizontalVec, new Cartesian3());
            const point = Cartesian3.add(pointInfo.position, slopeVec, new Cartesian3());
            const oppositeDir = new Cartesian3();
            Cartesian3.negate(parallelDirTowardsSelf, oppositeDir);
            const origin = Cartesian3.add(point, Cartesian3.multiplyByScalar(oppositeDir, 10, new Cartesian3()), new Cartesian3());
            const ray = new Ray(origin, parallelDirTowardsSelf);
            pointOnSlope = IntersectionTests.rayPlane(ray, pointInfo.crossSectionalplane);
            if (!pointOnSlope) {
                Cartesian3.clone(oppositeDir, ray.direction);
                pointOnSlope = IntersectionTests.rayPlane(ray, pointInfo.crossSectionalplane);
            }
            if (!pointOnSlope) {
                console.error("Error from unknown reason", pointInfo, oppositeDir);
            }
            const slopeDir = EarthBrainUtils.getDirBetweenTwoCartesians(pointInfo.position, pointOnSlope);
            slopeRay = new Ray(pointInfo.position, slopeDir);
        }
        return { ray: slopeRay, point: pointOnSlope };
    }
    getShelfPoint(pointInfo, verticalDirection, setting) {
        let parallelDirTowardsSelf;
        let perpendicularOutDir;
        if (pointInfo.back) {
            parallelDirTowardsSelf = EarthBrainUtils.getDirBetweenTwoCartesians(pointInfo.back.probablePosition, pointInfo.probablePosition);
            const vDir = Cartesian3.cross(parallelDirTowardsSelf, pointInfo.outwardDirection, new Cartesian3());
            perpendicularOutDir = Cartesian3.cross(vDir, parallelDirTowardsSelf, new Cartesian3()); //perpendicular outward
            Cartesian3.normalize(perpendicularOutDir, perpendicularOutDir);
        }
        else if (pointInfo.front) {
            parallelDirTowardsSelf = EarthBrainUtils.getDirBetweenTwoCartesians(pointInfo.front.probablePosition, pointInfo.probablePosition);
            const vDir = Cartesian3.cross(parallelDirTowardsSelf, pointInfo.outwardDirection, new Cartesian3());
            perpendicularOutDir = Cartesian3.cross(vDir, parallelDirTowardsSelf, new Cartesian3()); //perpendicular outward
            Cartesian3.normalize(perpendicularOutDir, perpendicularOutDir);
        }
        let slopeRay;
        let pointOnSlope;
        if (parallelDirTowardsSelf && perpendicularOutDir) {
            const height = setting.shelfSlope === 0 ? 0 : setting.shelfWidth / setting.shelfSlope;
            const verticalVec = Cartesian3.multiplyByScalar(verticalDirection, height, new Cartesian3());
            const horizontalVec = Cartesian3.multiplyByScalar(perpendicularOutDir, setting.shelfWidth, new Cartesian3());
            const slopeVec = Cartesian3.add(verticalVec, horizontalVec, new Cartesian3());
            const point = Cartesian3.add(pointInfo.position, slopeVec, new Cartesian3());
            const oppositeDir = new Cartesian3();
            Cartesian3.negate(parallelDirTowardsSelf, oppositeDir);
            const origin = Cartesian3.add(point, Cartesian3.multiplyByScalar(oppositeDir, 10, new Cartesian3()), new Cartesian3());
            const ray = new Ray(origin, parallelDirTowardsSelf);
            pointOnSlope = IntersectionTests.rayPlane(ray, pointInfo.crossSectionalplane);
            if (!pointOnSlope) {
                console.log("!!!!! D3D-353 bug may caused here !!!!");
                Cartesian3.clone(oppositeDir, ray.direction);
                pointOnSlope = IntersectionTests.rayPlane(ray, pointInfo.crossSectionalplane);
            }
            if (!pointOnSlope) {
                console.error("Error from unknown reason", pointInfo, oppositeDir);
                return { ray: undefined, point: undefined };
            }
            const slopeDir = EarthBrainUtils.getDirBetweenTwoCartesians(pointInfo.position, pointOnSlope);
            slopeRay = new Ray(pointInfo.position, slopeDir);
        }
        return { ray: slopeRay, point: pointOnSlope };
    }
}
//# sourceMappingURL=plane-slope-strategy.js.map